const PageHeader = ({ children }) => {
  return (
    <h3 className='font-[700] capitalize text-[32px] leading-[36.9px] tracking-[-2%] text-[#0d0f11]'>
      {children}
    </h3>
  )
}

export default PageHeader
